import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  gridSkeleton: {
    borderRadius: "15px",
    backgroundColor: "#fff",
    width: "100%",
  },
  pageBox: {
    margin: "5% 0",
    display: "grid",
    gridTemplateColumns: "15% 35% 35%",
    columnGap: "5%",
    height: "7vh",
    backgroundColor: "#e3e3e3",
  },
}));

export default useStyles;
